import React, { useContext } from 'react';
import cls from 'classnames';
import { FormattedMessage, FormattedRelative, FormattedDate } from 'react-intl';
import { Global } from '../../App';

/**
 * @param {object} props
 * @param {function} props.onClose
 */
function ChangeFontSize({ onClose, userType }) {
  const { globalState, dispatchGlobal } = useContext(Global);
  return (
    <>
      <div
        className={cls('pr-3 pl-3 font-regular', userType)}
        style={{
          color: globalState.fontSize === 'sm' ? '#B69E60' : '#4A4A4A',
          fontSize: '13px'
        }}
        children={<FormattedMessage id="header.fontSize.regular" />}
        onClick={() => {
          dispatchGlobal({
            type: 'UPDATE',
            payload: [{ key: 'fontSize', val: 'sm' }]
          });
          onClose();
        }}
      />
      <div
        className={cls('pr-3 pl-3 font-bigger', userType)}
        style={{
          color: globalState.fontSize === 'xl' ? '#B69E60' : '#4A4A4A',
          fontSize: '18px'
        }}
        children={<FormattedMessage id="header.fontSize.bigger" />}
        onClick={() => {
          dispatchGlobal({
            type: 'UPDATE',
            payload: [{ key: 'fontSize', val: 'xl' }]
          });
          onClose();
        }}
      />
    </>
  );
}

export default ChangeFontSize;
